import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Form, Typography } from "antd";
import GradientButton from "../../../common/UI/GradientButton";
import SHIPPING_FORM, { FORM_ID } from "./constants";
import useShippingForm from "./hooks/useShippingForm";
import { ShippingFormProps } from "./types";
import OrderSummary from "./components/OrderSummary";
import ShippingFields from "./components/ShippingFields";
import "./index.scss";

const { Text, Title } = Typography;

const ShippingForm: React.FC<ShippingFormProps> = ({
  product,
  initialValues,
  onBack,
  onSubmit,
}) => {
  const { form, formInitialValues } = useShippingForm({ initialValues });

  return (
    <article className="sf-root-container">
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={onBack}
        className="sf-back-btn"
      >
        {SHIPPING_FORM.LABELS.BACK}
      </Button>

      <div className="sf-root">
        {/* ── Left: form card ── */}
        <div className="sf-form-card">
          <div className="sf-form-header">
            <Title level={2} className="sf-form-title">
              {SHIPPING_FORM.LABELS.TITLE}
            </Title>
            <Text className="sf-form-subtitle">
              {SHIPPING_FORM.LABELS.SUBTITLE}
            </Text>
          </div>

          <Form
            id={FORM_ID}
            form={form}
            layout="vertical"
            requiredMark={false}
            initialValues={formInitialValues}
            onFinish={onSubmit}
            className="sf-form"
          >
            <ShippingFields />
          </Form>

          <div className="sf-form-footer">
            <GradientButton
              htmlType="submit"
              form={FORM_ID}
              className="sf-continue-btn"
            >
              {SHIPPING_FORM.LABELS.CONTINUE}
            </GradientButton>
          </div>
        </div>

        {/* ── Right: order summary ── */}
        <OrderSummary product={product} />
      </div>
    </article>
  );
};

export default ShippingForm;
